import MaskaModeluSelectSelect from './MaskaModeluSelect.vue';
import PpNrSelect from './PpNrSelect.vue';
import PpDescSelect from './PpDescSelect.vue';

export const components = { MaskaModeluSelectSelect, PpNrSelect, PpDescSelect };
